import axios from "@/axios";
import store from "@/store";

const state = {
  discounts: [],
  discount_product: false,
  loading: false,
};

const getters = {
  orderdiscountsLoading: (state) => {
    return state.loading;
  },

  retrieveDiscounts: (state) => {
    return state.discounts;
  },

  retrieveDiscountProduct: (state) => {
    return state.discount_product;
  },
};

const actions = {
  async clearDiscounts({ commit }) {
    commit("setDiscounts", []);
    commit("setLoading", false);
  },

  async setOrderDiscountsEnabledFlag({ commit }, value) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      value: value,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    commit("setLoading", true);

    const response = await axios
      .post("orderdiscounts/set-order-discounts-enabled-flag", params)
      .catch((er) => {
        return false;
      });

    if (response) {
      if (response.data.success == true) {
        console.log("-- Response Data");
        console.log(response.data);

        await store.dispatch("getConfigs");

        commit("setLoading", false);
        return response.data.success;
      } else {
        commit("setLoading", false);

        store.dispatch("setSnackbar", {
          color: "error",
          text: "Unable to change setting",
        });

        return response.data.success;
      }
    } else {
      commit("setLoading", false);

      store.dispatch("setSnackbar", {
        color: "error",
        text: "Server Connection Error",
      });

      return false;
    }
  },

  async getAllDiscounts({ commit }) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    commit("setLoading", true);

    const response = await axios
      .post("orderdiscounts/get-all-discounts", params)
      .catch((er) => {
        return false;
      });

    commit("setLoading", false);

    if (response) {
      if (response.data.success == true) {
        console.log("-- Response Data");
        console.log(response.data);
        commit("setDiscounts", response.data.discounts);
        commit("setDiscountProduct", response.data.discount_product);
        return {
          success: response.data.success,
          address: response.data.discounts,
        };
      } else {
        commit("setDiscounts", []);
        commit("setDiscountProduct", false);

        store.dispatch("setSnackbar", {
          color: "error",
          text: "Error finding discounts",
        });

        return {
          success: response.data.success,
          address: {},
        };
      }
    } else {
      store.dispatch("setSnackbar", {
        color: "error",
        text: "Server Connection Error",
      });

      return false;
    }
  },

  async addDiscount({ commit }, data) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      data: data,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    commit("setLoading", true);

    const response = await axios
      .post("orderdiscounts/add-discount", params)
      .catch((er) => {
        return false;
      });

    if (response) {
      if (response.data.success == true) {
        console.log("-- Response Data");
        console.log(response.data);

        // await store.dispatch("getAllDiscounts");

        commit("setLoading", false);
        return response.data.success;
      } else {
        commit("setLoading", false);

        store.dispatch("setSnackbar", {
          color: "error",
          text: response.data.message,
        });

        return response.data.success;
      }
    } else {
      commit("setLoading", false);

      store.dispatch("setSnackbar", {
        color: "error",
        text: "Server Connection Error",
      });

      return false;
    }
  },

  async deleteDiscount({ commit }, id) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      id: id,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    commit("setLoading", true);

    const response = await axios
      .post("orderdiscounts/delete-discount", params)
      .catch((er) => {
        return false;
      });

    if (response) {
      if (response.data.success == true) {
        console.log("-- Response Data");
        console.log(response.data);

        await store.dispatch("getAllDiscounts");

        commit("setLoading", false);
        return response.data.success;
      } else {
        commit("setLoading", false);

        store.dispatch("setSnackbar", {
          color: "error",
          text: response.data.message,
        });

        return response.data.success;
      }
    } else {
      commit("setLoading", false);

      store.dispatch("setSnackbar", {
        color: "error",
        text: "Server Connection Error",
      });

      return false;
    }
  },

  async updateDiscount({ commit }, data) {
    let payload = {
      userId: this.getters.retrieveUser.userNum,
      sessionKey: this.getters.retrieveUser.sessionKey,
      data: data,
    };

    let stringPayload = JSON.stringify(payload);
    const params = new URLSearchParams();
    params.append("params", stringPayload);

    commit("setLoading", true);

    const response = await axios
      .post("orderdiscounts/update-discount", params)
      .catch((er) => {
        return false;
      });

    if (response) {
      if (response.data.success == true) {
        console.log("-- Response Data");
        console.log(response.data);

        await store.dispatch("getAllDiscounts");

        commit("setLoading", false);
        return response.data.success;
      } else {
        commit("setLoading", false);

        store.dispatch("setSnackbar", {
          color: "error",
          text: response.data.message,
        });

        return response.data.success;
      }
    } else {
      commit("setLoading", false);

      store.dispatch("setSnackbar", {
        color: "error",
        text: "Server Connection Error",
      });

      return false;
    }
  },
};

const mutations = {
  setDiscounts: (state, value) => (state.discounts = value),
  setLoading: (state, value) => (state.loading = value),
  setDiscountProduct: (state, value) => (state.discount_product = value),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
